import Api from "./Api";
import store from "../state/store";

export default {

    getGridEmergecyListData() {
      return Api().get(`/emergency_list/${store.getters["authfack/currentEntity"].id}`);
    },
    getGridEmergencySessionsListData() {
      return Api().get(`/emergencies/${store.getters["authfack/currentEntity"].id}`);
    },
    getActiveSessions() {
      return Api().get(`/check_active_sessions/${store.getters["authfack/currentEntity"].id}`);
    },
    startSession(payload) {
      return Api().post('/start_emergency', payload);
    },
    endSession(id) {
      return Api().put(`/end_emergency/${id}`);
    },
    getEmergency(payload) {
      return Api().get(`/get_emergency/${payload.id}`, { params : {
        sites : payload.params.sites,
        areas : payload.params.areas,
      }});
    },
    changeUserStatusSession(payload) {
      return Api().put(`/action_emergency/${payload.id}` , payload);
    },
    getAreasWithSession() {
      return Api().get(`/areas_with_session/${store.getters["authfack/currentEntity"].id}`);
    },
    havePermissionWithSession(id) {
      return Api().get(`/check_have_premissions_to_emergency_session/${id}`);
    },
    checkEndSessionPermission(id) {
      return Api().get(`/check_have_premissions_to_end_session/${id}`);
    },
};